<span bottom
      [class]="'bar-button'"
      [pTooltip]="buttonTitle|translate"
      (click)="op.toggle($event)">
    <i *ngIf="inProgressCount>0" [class]="'bar-button-ico fa-solid fa-filter-circle-dollar'"  pBadge
       [value]="inProgressCount" ></i>
    <i *ngIf="inProgressCount===0" [class]="'bar-button-ico fa-solid fa-filter-circle-dollar'"></i>
    <div class="bar-button-text">{{buttonTitle|translate}}</div>
  </span>
<p-overlayPanel #op [showCloseIcon]="true" [style.width]="'80vw'" [style.minWidth]="'80vw'" [style.maxWidth]="'80vw'" [dismissable]="true">
  <ng-template pTemplate>
    <app-pl-residual-table  class="app-pl-residual-table-button" [transPartKey]="transPartKey"
                                [visible]="op.overlayVisible"
                                [selectedOrderIds]="selectedOrderIds"
                                [tradeModeEnabled]="tradeModeEnabled"></app-pl-residual-table>
  </ng-template>
</p-overlayPanel>
